import React, { useState, useEffect } from "react";
import "../App.css";

import Axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import { MDBInput, MDBSwitch, MDBTextArea, MDBBtn } from "mdb-react-ui-kit";

import DatePicker, { registerLocale } from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css'
import de from "date-fns/locale/de";
import Moment from 'moment';
import {backendPathCustomers, backendPathOfficeEmployees, backendPathPartners, tariffs} from "../Constants";
import Select from "react-select";
import {loadPermissions} from "../functions/permissions";
import TopNavbar from "../components/Navbar";


registerLocale("de", de);
Moment.locale('de');


function EditCustomer() {
    const { id } = useParams();
    const navigate = useNavigate();

    const [partners, setPartners] = useState([]);
    const [officeEmployees, setOfficeEmployees] = useState([]);

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [phoneNumber, setPhoneNumber] = useState(0);
    const [street, setStreet] = useState("");
    const [houseNumber, setHouseNumber] = useState("");
    const [zip, setZIP] = useState(0);
    const [city, setCity] = useState("");
    const [birthday, setBirthday] = useState();
    const [insurance, setInsurance] = useState("");
    const [degreeOfCare, setDegreeOfCare] = useState(0);
    const [secondPerson, setSecondPerson] = useState(0);
    const [name2, setName2] = useState("");
    const [surname2, setSurname2] = useState("");
    const [phoneNumber2, setPhoneNumber2] = useState(0);
    const [street2, setStreet2] = useState("");
    const [houseNumber2, setHouseNumber2] = useState("");
    const [zip2, setZIP2] = useState(0);
    const [city2, setCity2] = useState("");
    const [birthday2, setBirthday2] = useState();
    const [insurance2, setInsurance2] = useState("");
    const [degreeOfCare2, setDegreeOfCare2] = useState(0);
    const [thirdPerson, setThirdPerson] = useState(0);
    const [name3, setName3] = useState("");
    const [surname3, setSurname3] = useState("");
    const [phoneNumber3, setPhoneNumber3] = useState(0);
    const [relation3, setRelation3] = useState("");
    const [escalation, setEscalation] = useState("");
    const [annotation, setAnnotation] = useState("");
    const [inactive, setInactive] = useState(0);
    const [tariff, setTariff] = useState(null);
    const [partnerID, setPartnerID] = useState(-1);
    const [partnerLabel, setPartnerLabel] = useState("");
    const [officeEmployeeID, setOfficeEmployeeID] = useState(-1);
    const [officeEmployeeLabel, setOfficeEmployeeLabel] = useState("");

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);

    const [submitted, setSubmitted] = useState(false);

    const getCustomer = () => {
        Axios.get(`${backendPathCustomers}customer.php?id=${id}`).then((response) => {
            const customer = response.data[0];
            setName(customer.FirstName);
            setSurname(customer.LastName);
            setPhoneNumber(customer.PhoneNumber);
            setStreet(customer.Street);
            setHouseNumber(customer.HouseNumber);
            setZIP(customer.ZIP);
            setCity(customer.City);
            setBirthday(new Date(customer.Birthday));
            setInsurance(customer.Insurance);
            setDegreeOfCare(customer.DegreeOfCare);
            setSecondPerson(customer.SecondPerson);
            setName2(customer.FirstName2);
            setSurname2(customer.LastName2);
            setPhoneNumber2(customer.PhoneNumber2);
            setStreet2(customer.Street2);
            setHouseNumber2(customer.HouseNumber2);
            setZIP2(customer.ZIP2);
            setCity2(customer.City2);
            setBirthday2(customer.Birthday2 ? new Date(customer.Birthday2) : "");
            setInsurance2(customer.Insurance2);
            setDegreeOfCare2(customer.DegreeOfCare2);
            setThirdPerson(customer.ThirdPerson);
            setName3(customer.FirstName3);
            setSurname3(customer.LastName3);
            setPhoneNumber3(customer.PhoneNumber3);
            setRelation3(customer.Relation3);
            setEscalation(customer.Escalations);
            setAnnotation(customer.Annotation);
            setInactive(customer.Inactive);
            setTariff(customer.Tariff);
            setPartnerID(customer.PartnerId);
            setPartnerLabel(customer.PartnerName);
            setOfficeEmployeeID(customer.OfficeEmployeeID);
            setOfficeEmployeeLabel(customer.OfficeEmployeeFirstName + " " + customer.OfficeEmployeeLastName)
        });
    };

    const getPartners = () => {
        Axios.get(backendPathPartners+"partners.php").then((response) => {
            setPartners(response.data.map((val, key) => {
                console.log(response.data);
                return {label: val.Name, value: val.PartnerID };
            }));
        });
    };

    const getOfficeEmployees = () => {
        Axios.get(backendPathOfficeEmployees+"office-employees.php").then((response) => {
            setOfficeEmployees(response.data.map((val, key) => {
                console.log(response.data);
                return {label: val.FirstName + " " + val.LastName, value: val.OfficeEmployeeID };
            }));
        });
    };

    const handleChangeRaw = (date) => {
        console.log("raww");
        const newRaw = new Date(date.currentTarget.value);
        if (newRaw instanceof Date && !isNaN(newRaw)) {
          setBirthday(newRaw);
        }
    };

    const checkCompleteness = () => {
        if (!name || !surname || !phoneNumber || !street || !houseNumber || !zip || !city || !birthday || !insurance || !degreeOfCare) {
            return false;
        }
        return zip.toString().length === 5;

    };

    const updateCustomer = () => {
        setSubmitted(true);

        if (!checkCompleteness()) {
            return;
        }

        Axios.get(backendPathCustomers+"update-customer.php", {
            params: {
                id: id,
                name: name,
                surname: surname,
                phoneNumber: phoneNumber,
                street: street,
                houseNumber: houseNumber,
                zip: zip,
                city: city,
                birthday: Moment(birthday).format("YYYY-MM-DD"),
                insurance: insurance,
                degreeOfCare: degreeOfCare,
                secondPerson: secondPerson,
                surname2: secondPerson ? surname2 : "",
                name2: secondPerson ? name2 : "",
                phoneNumber2: secondPerson ? phoneNumber2 : 0,
                street2: secondPerson ? street2 : "",
                houseNumber2: secondPerson ? houseNumber2 : "",
                zip2: secondPerson ? zip2 : 0,
                city2: secondPerson ? city2 : "",
                birthday2: secondPerson ? Moment(birthday2).format("YYYY-MM-DD") : "",
                insurance2: secondPerson ? insurance2 : "",
                degreeOfCare2: secondPerson ? degreeOfCare2 : "",
                thirdPerson: thirdPerson,
                surname3: thirdPerson ? surname3 : "",
                name3: thirdPerson ? name3 : "",
                phoneNumber3: thirdPerson ? phoneNumber3 : "",
                relation3: thirdPerson ? relation3 : "",
                escalation: escalation ? escalation : "",
                annotation: annotation ? annotation : "",
                inactive: inactive,
                tariff: tariff ? tariff : null,
                partnerId: partnerID,
                officeEmployeeId: officeEmployeeID,
            }
        }).then(() => {
            console.log(name, surname, street, houseNumber, zip, city, Moment(birthday).format("YYYY-MM-DD"), insurance, degreeOfCare, secondPerson, name2, surname2, street2, houseNumber2, zip2, city2, Moment(birthday2).format("YYYY-MM-DD"), insurance2, degreeOfCare2, thirdPerson, name3, surname3, relation3, escalation, annotation, partnerID);
            navigate("/customer/" + id);
        });
        
    };

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);

    useEffect(() => {
        getCustomer();
        getPartners();
        getOfficeEmployees();
    }, [id]);

    return (
        <div>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>
            <div className="main">
                <div className="header">
                    <h2>Kunde bearbeiten</h2>
                </div>

                <div className='input-form'>
                    <MDBInput className="input" label='Vorname' type='text' value={name} onChange={(event) => {
                        setName(event.target.value);
                    }}/>
                    {(submitted && !name) ?
                        <p className="validation-label">Vorname darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input" label='Nachname' type='text' value={surname} onChange={(event) => {
                        setSurname(event.target.value);
                    }}/>
                    {(submitted && !surname) ?
                        <p className="validation-label">Nachname darf nicht leer sein.</p> : null
                    }

                    <div className="input">
                        <MDBSwitch label={!inactive ? "Status aktiv" : "Status inaktiv"} checked={!inactive}
                                   onChange={(event) => setInactive(s => (s + 1) % 2)}/>
                    </div>

                    <MDBInput className="input col-md-6" label='Telefon' type='number' value={phoneNumber}
                              onChange={(event) => {
                                  setPhoneNumber(event.target.value);
                              }}/>
                    {(submitted && !phoneNumber) ?
                        <p className="validation-label">Telefonnummer darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Straße' type='text' value={street}
                              onChange={(event) => {
                                  setStreet(event.target.value);
                              }}/>
                    {(submitted && !street) ?
                        <p className="validation-label">Straße darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Hausnummer' type='text' value={houseNumber}
                              onChange={(event) => {
                                  setHouseNumber(event.target.value);
                              }}/>
                    {(submitted && !houseNumber) ?
                        <p className="validation-label">Hausnummer darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Postleitzahl' id='form2' type='number' value={zip}
                              onChange={(event) => {
                                  setZIP(event.target.value);
                              }}/>
                    {(submitted && !zip) ?
                        <p className="validation-label">Postleitzahl darf nicht leer sein oder Text
                            enthalten.</p> : null
                    }
                    {(submitted && zip && zip.toString().length !== 5) ?
                        <p className="validation-label">Postleitzahl ist nicht gültig.</p> : null
                    }

                    <MDBInput className="input col-md-6" label='Stadt' id='form2' type='text' value={city}
                              onChange={(event) => {
                                  setCity(event.target.value);
                              }}/>
                    {(submitted && !city) ?
                        <p className="validation-label">Stadt darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Geburtsdatum</p>
                    <DatePicker className="date-input-1" locale="de" dateFormat='dd.MM.yyyy' selected={birthday}
                                onChange={date =>
                                    setBirthday(date)}
                    />
                    {(submitted && !birthday) ?
                        <p className="validation-label-date">Geburtsdatum darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Partner</p>
                    <Select className="input" id="select1" placeholder={'Auswählen...'} options={partners}
                            value={partnerID > 0 ? {label: partnerLabel, value: partnerID} : null}
                            onChange={(event) => {
                                console.log(event);
                                setPartnerID(event.value);
                                setPartnerLabel(event.label);
                            }}/>

                    <p className="input-label">Paket</p>
                    <Select className="input" id="select2" placeholder={'Auswählen...'} options={tariffs}
                            value={tariff >= 0 ? tariffs[tariff] : ""} onChange={(event) => {
                        setTariff(event.value);
                    }}/>

                    <MDBInput className="input col-md-6" label='Pflegekasse' id='form2' type='text' value={insurance}
                              onChange={(event) => {
                                  setInsurance(event.target.value);
                              }}/>
                    {(submitted && !insurance) ?
                        <p className="validation-label">Pflegekasse darf nicht leer sein.</p> : null
                    }

                    <p className="input-label">Zuständiger Mitarbeiter</p>
                    <Select className="input" id="select3" placeholder={'Auswählen...'} options={officeEmployees}
                            value={officeEmployeeID > 0 ? {label: officeEmployeeLabel, value: officeEmployeeID} : null}
                            onChange={(event) => {
                                console.log(event);
                                setOfficeEmployeeID(event.value);
                                setOfficeEmployeeLabel(event.label);
                            }}/>

                    <MDBInput className="input col-md-6" label='Pflegegrad' id='form2' type='number'
                              value={degreeOfCare} onChange={(event) => {
                        setDegreeOfCare(event.target.value);
                    }}/>
                    {(submitted && !degreeOfCare) ?
                        <p className="validation-label">Pflegegrad darf nicht leer oder Text sein.</p> : null
                    }

                    <div className="input"><MDBSwitch label='zweite Person zu betreuen' checked={secondPerson}
                                                      onChange={(event) => setSecondPerson(s => (s + 1) % 2)}/></div>

                    {secondPerson ?
                        <div className="sub-input">
                            <MDBInput className="input" label='Vorname' color="primary" id='form1' type='text'
                                      value={name2 ? name2 : ""} onChange={(event) => {
                                setName2(event.target.value);
                            }}/>
                            <MDBInput className="input" label='Nachname' id='form2' type='text'
                                      value={surname2 ? surname2 : ""} onChange={(event) => {
                                setSurname2(event.target.value);
                            }}/>
                            <MDBInput className="input col-md-6" label='Telefon' type='number' value={phoneNumber2}
                                      onChange={(event) => {
                                          setPhoneNumber2(event.target.value);
                                      }}/>
                            <MDBInput className="input col-md-6" label='Straße' id='form2' type='text'
                                      value={street2 ? street2 : ""} onChange={(event) => {
                                setStreet2(event.target.value);
                            }}/>
                            <MDBInput className="input col-md-6" label='Hausnummer' id='form2' type='text'
                                      value={houseNumber2 ? houseNumber2 : ""} onChange={(event) => {
                                setHouseNumber2(event.target.value);
                            }}/>
                            <MDBInput className="input col-md-6" label='Postleitzahl' id='form2' type='number'
                                      value={zip2 ? zip2 : ""} onChange={(event) => {
                                setZIP2(event.target.value);
                            }}/>
                            <MDBInput className="input col-md-6" label='Stadt' id='form2' type='text'
                                      value={city2 ? city2 : ""} onChange={(event) => {
                                setCity2(event.target.value);
                            }}/>
                            <p className="input-label">Geburtsdatum</p>
                            <DatePicker className="date-input" locale="de" dateFormat='dd.MM.yyyy' selected={birthday2}
                                        onChangeRaw={(e) => handleChangeRaw(e)}
                                        onChange={date => setBirthday2(date)}
                            />
                            <MDBInput className="input col-md-6" label='Pflegekasse' id='form2' type='text'
                                      value={insurance2 ? insurance2 : ""} onChange={(event) => {
                                setInsurance2(event.target.value);
                            }}/>
                            <MDBInput className="input col-md-6" label='Pflegegrad' id='form2' type='number'
                                      value={degreeOfCare2 ? degreeOfCare2 : ""} onChange={(event) => {
                                setDegreeOfCare2(event.target.value);
                            }}/>
                        </div>
                        : null}

                    <div className="input"><MDBSwitch id='licenseSwitch' label='zweite Person im Haushalt'
                                                      checked={thirdPerson}
                                                      onChange={(event) => setThirdPerson(s => (s + 1) % 2)}/></div>

                    {thirdPerson ?
                        <div id="third-person">
                            <div className="sub-input">
                                <MDBInput className="input" label='Vorname' color="primary" id='form1' type='text'
                                          value={name3 ? name3 : ""} onChange={(event) => {
                                    setName3(event.target.value);
                                }}/>
                                <MDBInput className="input" label='Nachname' id='form2' type='text'
                                          value={surname3 ? surname3 : ""} onChange={(event) => {
                                    setSurname3(event.target.value);
                                }}/>
                                <MDBInput className="input col-md-6" label='Telefon' type='number' value={phoneNumber3}
                                          onChange={(event) => {
                                              setPhoneNumber3(event.target.value);
                                          }}/>
                                <MDBInput className="input" label='Beziehung' id='form2' type='text'
                                          value={relation3 ? relation3 : ""} onChange={(event) => {
                                    setRelation3(event.target.value);
                                }}/>
                            </div>
                        </div>
                        : null}

                    <MDBTextArea className="input" label='Eskalationen' id='textAreaExample' rows={4} value={escalation}
                                 onChange={(event) => {
                                     setEscalation(event.target.value);
                                 }}/>
                    <MDBTextArea className="input" label='Notizen' id='textAreaExample' rows={4} value={annotation}
                                 onChange={(event) => {
                                     setAnnotation(event.target.value);
                                 }}/>
                </div>

                <div className="footer">
                    <MDBBtn className="btn" type="submit" onClick={updateCustomer}>Speichern</MDBBtn>
                </div>

            </div>
        </div>
    );
}

export default EditCustomer;